import { render, staticRenderFns } from "./AccorderingTaken.vue?vue&type=template&id=e2835396"
import script from "./AccorderingTaken.vue?vue&type=script&lang=js"
export * from "./AccorderingTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports